/* eslint-disable */

import React from 'react';
import { withCookies } from 'react-cookie';
import { connect } from 'react-redux'
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import green from 'material-ui/colors/green';
import { CircularProgress } from 'material-ui/Progress';
import Input, { InputLabel } from 'material-ui/Input';
import {
  FormControl,
} from 'material-ui/Form';


import TodayIcon from 'material-ui-icons/Today';
import Typography from 'material-ui/Typography';

import Dialog from 'material-ui/Dialog/Dialog';
import DialogActions from 'material-ui/Dialog/DialogActions';
import DialogContent from 'material-ui/Dialog/DialogContent';
import DialogTitle from 'material-ui/Dialog/DialogTitle';

import InfiniteCalendar from 'react-infinite-calendar';
import 'react-infinite-calendar/styles.css';

import { translate } from "react-i18next";

import MenuItem from 'material-ui/Menu/MenuItem';
import TextField from 'material-ui/TextField';
import Tooltip from 'material-ui/Tooltip';
import Button from 'material-ui/Button';
import { withRouter } from 'react-router'

import moment from 'moment';

import {
  assetIdChanged,
  powerInWhChanged,
  createCertificateStart,
  getAssetsProducingStart,
  toggleProductionDateDialog,
  setProductionDate,
} from '../actions'

import { checkUserIsAdmin } from '../utils/user/checkAdmin/CheckAdmin';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'center',
  },
  margin: {
    margin: theme.spacing.unit,
  },
  withoutLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  textField: {
    flexBasis: 200,
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

class FormCertificates extends React.Component {

  static contextTypes = {
    router: PropTypes.func.isRequired
  };

  accounts = [];


  componentDidMount = () => {
    const { isAuthenticated, user } = this.props;

    if(checkUserIsAdmin(isAuthenticated, user)) {
      this.props.getAssetsProducingStart();
      const { match: { params } } = this.props;
    } else {
      this.props.history.push('/')
    }
  };


  handleAssetIdChange = () => event => {

    this.props.assetIdChanged(event.target.value);
  };

  handlePowerInWhChange = () => event => {

    this.props.powerInWhChanged(event.target.value);
  };

  handleClickProductionDateOpen = () => {
    this.props.toggleProductionDateDialog();
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleClickProductionDateClose = () => {
    this.props.toggleProductionDateDialog();
  };


  render() {
    const { classes, assetsProducing, currentCertificate, loading, dialogProductionDateOpen, t, cookies } = this.props;


    let csrfToken = cookies.cookies._csrf;
    const buttonClassname = classNames({
      [classes.buttonSuccess]: loading,
    });




    return (
      <div className={classes.root}>
        <form>
          <input type="hidden" name="_csrf" value={{csrfToken}}/>
          <FormControl style={{ width: 167 }}>
            <div style={{
              position: 'absolute',
              top: -8,
              left: 19
              }}>
              <Typography variant="caption" gutterBottom align="left">
                {t("Production date")}
              </Typography>
            </div>
            <div style={{marginTop: 5 }}>
              <Tooltip title={t("Matching date")}>
                <Button className={classes.button} onClick={() => this.props.toggleProductionDateDialog()}>
                  <TodayIcon style={{ color: 'rgba(0, 0, 0, 0.54)'}} className={classNames(classes.leftIcon, classes.iconSmall)}/>
                  <Typography variant="caption" gutterBottom align="left">
                    {moment(currentCertificate.productionDate).format('DD/MM/YYYY')}
                  </Typography>
                </Button>
              </Tooltip>
            </div>
          </FormControl>
          <TextField
            id="select-asset"
            select
            label="Select"
            className={classes.textField}
            value={currentCertificate && currentCertificate.assetId ? currentCertificate.assetId : 0}
            onChange={this.handleAssetIdChange()}
            SelectProps={{
              MenuProps: {
                className: classes.menu,
              },
            }}
            helperText="Please select the certificate's asset"
            margin="normal"
          >
            {assetsProducing.map(asset => (
              <MenuItem key={asset.id} value={asset.id}>
                {asset.offchainData.displayedName}
              </MenuItem>
            ))}
          </TextField>
          <FormControl className={classNames(classes.margin, classes.textField)}>
            <InputLabel htmlFor="adornment-power">Power in Wh</InputLabel>
            <Input
              id="adornment-power"
              type='text'
              value={ currentCertificate && currentCertificate.powerInW ? currentCertificate.powerInW : '' }
              autoComplete="power"
              onChange={this.handlePowerInWhChange()}
            />
          </FormControl>
          <div className={classes.wrapper}>
            <Button
              variant="raised"
              color="primary"
              className={buttonClassname}
              disabled={loading}
              onClick={() => this.props.createCertificateStart(this.props.currentCertificate, this.props.history)}
            >
              Create Certificate
            </Button>
            {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
          </div>
        </form>

        <Dialog
          fullScreen={false}
          open={dialogProductionDateOpen}
          onClose={this.props.toggleProductionDateDialog}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">Production Date</DialogTitle>
          <DialogContent>
            <InfiniteCalendar
              width={400}
              height={600}
              display={"years"}
              selected={currentCertificate.productionDate}
              onSelect={(selectedProductionDate) => { this.props.setProductionDate(selectedProductionDate);}}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.toggleProductionDateDialog} color="primary" autoFocus>
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>

    );
  }
}

FormCertificates.contextTypes = {
  router: PropTypes.object
}
FormCertificates.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({ certificatesReducer, assetsProducingReducer, router, loginReducer }) => {
  const { assetsProducing } = assetsProducingReducer;
  const { certificates, currentCertificate, loading, dialogProductionDateOpen, productionDate } = certificatesReducer;
  const { location } = router;
  const { isAuthenticated, username, user } = loginReducer;
  return { assetsProducing, certificates, currentCertificate, loading, location, isAuthenticated, username, user, dialogProductionDateOpen, productionDate };
};



const mapDispatchToProps = {
  assetIdChanged,
  powerInWhChanged,
  createCertificateStart,
  getAssetsProducingStart,
  toggleProductionDateDialog,
  setProductionDate,
}


FormCertificates = withStyles(styles, {name: 'FormCertificates'})(FormCertificates);
FormCertificates = translate("translations")(FormCertificates);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withCookies(FormCertificates)))



// WEBPACK FOOTER //
// ./src/components/FormCertificates.js